import React from 'react'
import { Route } from 'react-router-dom'
import { withSentryRouting } from '@sentry/react'

const RouteWithSentry = withSentryRouting(Route)

const ModalRoute = (props) => {
    return <RouteWithSentry {...props} />
}

export default ModalRoute
